import React, { useCallback, useState } from 'react';
export const IFrameContainer = props => {
  const [size, setSize] = useState(null);
  const setContainerRef = useCallback(div => {
    if (!div) {
      return;
    }
    const height = Math.ceil(div.clientHeight);
    const width = Math.ceil(height / 9 * 16);
    setSize({
      width,
      height
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: setContainerRef,
    style: {
      height: '100%',
      background: 'black',
      display: 'flex',
      justifyContent: 'center'
    }
  }, size ? props.children(size) : null);
};
//# sourceMappingURL=IFrameContainer.js.map